export const getSuperSpeedProductIdFromLS = () => null;
export const getSuperSpeedFromLS = () => false;
export const setSuperSpeedProductIdInLS = () => null;
export const removeSuperSpeedProductIdFromLS = () => null;